<div
  class="content-body"
  [ngClass]="(isViewPermission$ | async) ? 'is-readonly' : ''"
>
  <form [formGroup]="submitVatForm">
    <div class="d-flex gap-30">
      <div class="form-field datepicker">
        <p>From</p>
        <mat-form-field appearance="fill">
          <input
            matInput
            formControlName="fromDate"
            [matDatepicker]="fromDatePicker"
            autocomplete="off"
            (keydown)="commonService.validateDate($event)"
            tabindex="-1"
            [disabled]="editdata"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="fromDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #fromDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="form-field datepicker">
        <p>To</p>
        <mat-form-field appearance="fill">
          <input
            matInput
            formControlName="toDate"
            [matDatepicker]="toDatePicker"
            autocomplete="off"
            (keydown)="commonService.validateDate($event)"
            tabindex="-1"
            [min]="this.submitVatForm.controls.fromDate.value"
            [disabled]="editdata"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="toDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #toDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div class="form-field wp-100 textarea">
      <p>Description</p>
      <mat-form-field>
        <textarea
          matInput
          formControlName="description"
          autocomplete="off"
        ></textarea>
      </mat-form-field>
    </div>
    <div class="checkbox">
      <mat-checkbox formControlName="finalReturn"
        >De-registered for VAT</mat-checkbox
      >
      <p class="w-434 mb-0">
        Please tick this box if this is your last VAT submission. This is only
        needed when you have already cancelled you VAT registration at the
        HMRC's end.
      </p>
      <a
        href="https://www.gov.uk/government/publications/vat-notice-70011-cancelling-your-registration/vat-notice-70011-cancelling-your-registration"
        target="_blank"
        class="link mr-1"
        >Please click here for more guidance.</a
      >
    </div>
  </form>
</div>
